module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-container",
    on: {
      "click": _vm.changeBoardState
    }
  }, [_c('div', {
    staticClass: "icon"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9aa574b2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/map_module/maptool/toolbar/search.vue
// module id = 68
// module chunks = 0